// extracted by mini-css-extract-plugin
export default {"icons_wrapper":"order-images_icons_wrapper__T1k1n","icon":"order-images_icon__mC2tS","last_icon":"order-images_last_icon__Lvst0","number":"order-images_number__AM2Lz"};